import React, { Fragment } from "react";
import Industry from "./Industry";

function IndustryExperience(props) {
    return (
        <Fragment>
            <div id="industry">
                <Industry />
            </div>
        </Fragment>
    )
}

export default IndustryExperience;
